import styled from 'styled-components'
import tw from 'twin.macro'
import { colors } from '../../themes/Colors'

export const FileInput = styled.input`
  ${tw`hidden`}
`
export const FileUploaderContainer = styled.div`
  ${tw`flex flex-col w-full`}
  ${(props) =>
    props.isDisabled ? tw`cursor-auto select-none` : tw`cursor-pointer`}
`
export const LoaderContaner = styled.div`
  ${tw`flex justify-center items-center rounded-[8px] border-[1px] border-dashed py-[12px]`}
  border-color: ${colors.coolGrey};
`
